import { crossIcon } from '../../../Assets/svg'
import { useDispatch, useSelector } from 'react-redux';
import MixerSection from './MixerSection';
import "./style.css"
import { GetMixerConfig } from '../../../Hooks/CurrentTracks';
import { removeAllTracks, removeSingleTrack, setCreatePlaylistType, setSelectedItem, setSelectedType } from '../../../Store/Slices/PlayerSlice';
import { setShowPaywallModal } from '../../../Store/Slices/UserSlice';
import { handleCreatePlaylistModal, handleSaveMixModal, handleShareMixModal, handleShareMixOnSave } from '../../../Store/Slices/ModalSlice';
import { useTranslation } from 'react-i18next';
import { cancelTimer } from '../../../Store/Slices/TimerSlice';

// 🔹 Mixer Tray Component

const MixerTray = ({ isOpen, onClose }) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    // get data to show in mixer tray
    // 1. Categorized data
    const categories = GetMixerConfig();

    // console.log(categories)

    // 2. Processed data
    const mixId = useSelector((state) => state.mixStatus.mixId);
    const config = useSelector((state) => state.player.config);
    const tracks = useSelector((state) => state.player.playingTracks);

    const checkElegibility = useSelector((state) => state.user.checkElegibility);

    // 🔹 ensure only one section gets clearable=true
    let clearableSet = false;
    // 🔹 UI state
    const isPlaylist = config['type'] === 'playlist';


    const onRemove = (item) => {
        dispatch(removeSingleTrack({ item }));
    }

    const onClearAll = () => {
        dispatch(removeAllTracks());
        dispatch(cancelTimer());
        localStorage.removeItem("originalPath");
    }

    const openShareMixModal = () => {
        if (!checkElegibility) {
            dispatch(setShowPaywallModal(true));
            return
        }
        dispatch(setSelectedType(isPlaylist ? 'playlist' : 'default'));
        dispatch(setSelectedItem(tracks));
        if (mixId != null) {
            dispatch(handleShareMixModal(true));
        } else {
            dispatch(handleShareMixOnSave(true));
            dispatch(handleSaveMixModal(true));
        }
    }

    const openSaveMixModal = () => {
        if (!checkElegibility) {
            dispatch(setShowPaywallModal(true));
            return
        }


        // const originalPath = localStorage.getItem("originalPath") || null;
        // const hasSoundsInTracks = tracks.some(track => track?.type === 'sounds' && track.soundcategory !== 164 && track.soundcategory !== 163);
        dispatch(setSelectedItem(tracks));

        if (isPlaylist && !config?.shouldPlay) {
            dispatch(setCreatePlaylistType(config?.playlist_type));
            dispatch(handleCreatePlaylistModal(true));
            return;
        }
        dispatch(setSelectedType(isPlaylist ? 'playlist' : 'default'));
        dispatch(handleSaveMixModal(true));
    }

    return (
        <>
            <div className={`d-flex flex-column mixerTray ${isOpen ? 'open' : 'close'}`}>
                <div className="mixerHeader flex-shrink-0 p-3 py-4">
                    <h3>
                        {config?.isPlaylistMix || !isPlaylist ? t("player.mixer") : t("header.playlist")}
                    </h3>
                    <div className="text-end d-flex align-items-center gap-2">
                        <button onClick={openSaveMixModal} className="notButton text-capitalize text-white" style={{ fontSize: 14 }}>{t("common.save")}</button>
                        {
                            (!isPlaylist || config?.isPlaylistMix) && (
                                <>
                                    |
                                    <button onClick={openShareMixModal} className="notButton text-capitalize text-white" style={{ fontSize: 14 }}>{t("player.share")}</button>
                                </>

                            )
                        }
                        <button className="notButton d-flex align-items-center ms-1" onClick={onClose} >
                            <img src={crossIcon} alt="Close Button" />
                        </button>
                    </div>
                </div>

                <div className="mixer-scroll-wrapper flex-grow-1 overflow-auto">

                    {Object.entries(categories).map(([key, item], index) => {
                        if (item.data.length === 0) return null; // skip empty array
                        let isClearable = false;

                        // ✅ only first valid iteration gets true
                        if (!clearableSet) {
                            isClearable = true;
                            clearableSet = true;
                        }

                        return (
                            <MixerSection
                                key={index}
                                // title={!config?.isPlaylistMix || !isPlaylist ? item.name : config.name}
                                title={config.type === 'playlist' || config.type === 'mix' ? config.name : item.name}
                                clearable={isClearable}
                                list={item.data}
                                onRemove={onRemove}
                                onClearAll={onClearAll}
                            />
                        );
                    })}

                </div>
            </div>
        </>
    )
};

export default MixerTray;